import { Badge } from '@shared/components';
import type { AgreementTimelineEntry } from '../types/agreementTimeline.types';
import { formatHistoryActor } from '../utils/formatHistoryActor';
import { formatOccurredAt, noteTypeLabel } from '../utils/timelineEntryLabels';

interface Props {
    entry: AgreementTimelineEntry;
}

export function AgreementNoteItem({ entry }: Props) {
    const actor = formatHistoryActor(entry);

    return (
        <li className="rounded-lg border border-mp-border p-4">
            <div className="flex flex-wrap items-center gap-x-3 gap-y-1">
                <Badge variant="info">{entry.kind === 'note' ? noteTypeLabel(entry.note.noteType) : 'Note'}</Badge>
                <p className="text-xs text-mp-muted">
                    <time dateTime={entry.occurredAt}>{formatOccurredAt(entry.occurredAt)}</time>
                    {actor && <span> · {actor}</span>}
                </p>
                {entry.crmCaseId && (
                    <span className="text-xs text-mp-muted">CRM case {entry.crmCaseId}</span>
                )}
            </div>
            {entry.kind === 'note' && (
                <p className="mt-3 whitespace-pre-wrap text-base leading-relaxed text-mp-foreground">
                    {entry.note.body}
                </p>
            )}
        </li>
    );
}
